import React, { ChangeEvent } from "react";
import type { NumberQuestion } from "@r6digital/rapidstor-types/types/Questionnaire";
import BigHeader from "../BigHeader";
import { Form, InputGroup } from "react-bootstrap";
import classes from "./Question.module.scss";
import store from "../../store";
import {
  deleteResponse,
  selectResponses,
  setResponse,
} from "../../store/questionnaireSlice";
import { useSelector } from "react-redux";

interface Props {
  id: string;
  question: NumberQuestion;
}

function NumberQuestion({ id, question }: Props) {
  const responses = useSelector(selectResponses);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === "") {
      store.dispatch(deleteResponse(id));
    } else {
      store.dispatch(setResponse({ id, response: Number(event.target.value) }));
    }
  };

  return (
    <div className={classes.numberQuestion}>
      <BigHeader className={classes.title}>{question.title}</BigHeader>

      <div className={"d-flex align-items-center"}>
        <InputGroup size={"lg"}>
          {question.prefix !== undefined && (
            <InputGroup.Text>{question.prefix}</InputGroup.Text>
          )}
          <Form.Control
            type="number"
            min={question.min}
            max={question.max}
            value={(responses?.[id] as number) || ""}
            onChange={onChange}
          />
        </InputGroup>
        {question.suffix !== undefined && (
          <div className={`ms-3 ${classes.suffix}`}>{question.suffix}</div>
        )}
      </div>
    </div>
  );
}

export default NumberQuestion;
